import api from "@/router/api";
import apiPublic from "@/router/apiPublic";

export default {
  // ─── Listagem geral (tela da ação) ────────────────────────────────────────
  async listarParcerias(params = {}) {
    const response = await api.get("/api/solicitacoes-parceria", { params });
    return response.data;
  },

  // Cards públicos de todas as ações
  async listarParceriasCards(params = {}) {
    const response = await apiPublic.get("/api/parcerias/cards", {
      params,
    });
    return response.data;
  },

  // Cards de solicitações de parceria de todas as ações (Swagger: GET /api/solicitacoes-parceria/cards)
  async listarSolicitacoesCards(params = {}) {
    const response = await api.get("/api/solicitacoes-parceria/cards", {
      params,
    });
    return response.data;
  },

  // Cards públicos de uma ação específica
  async listarParceriasCardsPorAcao(id) {
    const response = await apiPublic.get(`/api/parcerias/cards/${id}`);
    return response.data;
  },

  async criarParceria(dadosParceria) {
    const response = await api.post(
      "/api/solicitacoes-parceria",
      dadosParceria
    );
    return response.data;
  },

  async buscarParceriaPorId(id) {
    const response = await api.get(`/api/solicitacoes-parceria/${id}`);
    return response.data;
  },

  async enviarParceria(id) {
    const response = await api.patch(`/api/solicitacoes-parceria/${id}/enviar`);
    return response.data;
  },

  async cancelarSolicitacaoCoordenador(id, motivo) {
    const response = await api.patch(
      `/api/solicitacoes-parceria/${id}/cancelar`,
      { motivo }
    );
    return response.data;
  },

  async atualizarParceria(id, dadosParceria) {
    const response = await api.put(
      `/api/solicitacoes-parceria/${id}`,
      dadosParceria
    );
    return response.data;
  },

  async excluirParceria(id) {
    const response = await api.delete(`/api/solicitacoes-parceria/${id}`);
    return response.data;
  },

  async buscarStatus(id) {
    const response = await api.get(`/api/solicitacoes-parceria/${id}/status`);
    return response.data;
  },

  async listarAvaliacoesDaSolicitacao(solicitacaoId) {
    const response = await api.get(
      `/api/avaliacoes-parceria/solicitacao/${solicitacaoId}`
    );
    return response.data;
  },

  // ─── Endpoints exclusivos da PREX ─────────────────────────────────────────
  async listarParaAnalise(params = {}) {
    const response = await api.get("/api/solicitacoes-parceria", { params });
    return response.data;
  },

  async aprovar(id, payload = {}) {
    const response = await api.put(`/api/solicitacoes-parceria/${id}/avaliar`, {
      decisao: "PARCERIA_FORMALIZADA",
      comentario: payload.observacaoAnalise || "Parceria formalizada",
    });
    return response.data;
  },

  async rejeitar(id, motivo) {
    const response = await api.put(`/api/solicitacoes-parceria/${id}/avaliar`, {
      decisao: "REJEITADA",
      comentario: motivo,
    });
    return response.data;
  },

  // Transição genérica de status (cada chamada gera um registro no histórico)
  async alterarStatus(id, status, comentario = "") {
    const response = await api.put(`/api/solicitacoes-parceria/${id}/avaliar`, {
      decisao: status,
      comentario: comentario || "Status atualizado pela PREX",
    });
    return response.data;
  },

  // Parcerias externas importadas CSV
  async listarParceriasExternas(params = {}) {
    const response = await apiPublic.get("/parcerias-externas", {
      params,
    });
    return response.data;
  },

  // Parcerias externas importadas, vinculadas a uma ação específica
  async listarParceriasExternasPorAcao(acaoExtensaoId) {
    const response = await apiPublic.get(
      `/parcerias-externas/acao/${acaoExtensaoId}`
    );
    return response.data;
  },
};
